import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UpdateDocuments } from '@/interfaces/license-mine-update/license-mine-update.interface';
import { take, map, first } from 'rxjs/operators';
import { parseISOString } from '@/utils/parseISOString';
import { Details } from '@/interfaces/requirement';
import { AuthService } from '@/auth/service/auth.service';
import { Observable } from 'rxjs';
import { CacheService } from '@/utils/cacheService/cache.service';

@Injectable({
  providedIn: 'root',
})
export class LicenseMineUpdateService {

  constructor(
    private http: HttpClient,
    private cacheService: CacheService,
    private auth: AuthService,
  ) { }

  updateDocuments(params: UpdateDocuments, requirementId: number) {
    this.cacheService.remove('LicensesByUser');
    return this.http.post<UpdateDocuments>(`/Requirement/UpdateRequiredDocumentsMine/Requirement/${requirementId}`, params).pipe(take(1));
  }

  getLicenseDetailByMdmid(mdmid: string): Observable<Details> {
    const assetId = this.auth.getUserAssetId();
    const source$ = this.http.get<Details>(`/License/DetailsByQuery?driverMdmid=${mdmid}&assetId=${assetId}`)
      .pipe(
        map<any, Details>((details: any) => {
          let { documents, equipments } = details;
          documents = documents.map((document: any) => {
            let out = document;
            if (document.dateEmit) {
              out = { ...out, dateEmit: parseISOString(out.dateEmit) };
            }
            if (document.dateFrom) {
              out = { ...out, dateFrom: parseISOString(out.dateFrom) };
            }
            if (document.dateUntil) {
              out = { ...out, dateUntil: parseISOString(out.dateUntil) };
            }

            out.isMineRequired = document.documentRequirementUseTypeId;
            delete out.documentRequirementUseTypeId;

            return out;
          }).filter(({ isMineRequired }: any) => isMineRequired);

          equipments = equipments.map((equipment: any) => {
            if (equipment.expiredAt) {
              const expiredAt = parseISOString(equipment.expiredAt);
              return { ...equipment, expiredAt };
            }
            return equipment;
          });

          return <Details><unknown>{ ...details, documents, equipments };
        }),
        first(),
      );
    return this.cacheService.save<Details>(`License/DetailsByQuery${mdmid}_${assetId}`, 0.3, source$);
  }

}
